import React, { useState } from 'react'
import { Glyphicon } from 'react-bootstrap'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { swalNotify } from '../../../common/components/Swaler'
import { saveCarrierMappings } from '../../../common/redux/collectionActions'
import { getModalStyles } from '../../../common/utils'
import './styles.css'

export default ({ vendor, closeModal }) => {
    const dispatch = useDispatch()
    const carriers = useSelector(state => state.collectionData.carriers)

    const [carrierMappings, setCarrierMappings] = useState(vendor.carrierMappings || [])

    const addNewZip = (mapping) => {
        const updatedMapping = ([...carrierMappings]).map(carrierMapping => {
            if (mapping.carrier === carrierMapping.carrier) carrierMapping.zips += ";"
            return carrierMapping
        })

        setCarrierMappings(updatedMapping)
    }

    const removeZip = (mapping, zipIndex) => {
        const updatedMapping = ([...carrierMappings]).map(carrierMapping => {
            if (mapping.carrier === carrierMapping.carrier) {
                const filteredZips = carrierMapping.zips.split(';').filter((_, i) => i !== zipIndex)
                carrierMapping.zips = filteredZips.join(';')
            }

            return carrierMapping
        })

        setCarrierMappings(updatedMapping)
    }

    const modifyZip = (mapping, zipIndex, value) => {
        const updatedMapping = ([...carrierMappings]).map(carrierMapping => {
            if (mapping.carrier === carrierMapping.carrier) {
                const filteredZips = carrierMapping.zips.split(';').map((zip, i) => {
                    if (i === zipIndex) zip = value
                    return zip
                })
                carrierMapping.zips = filteredZips.join(';')
            }

            return carrierMapping
        })

        setCarrierMappings(updatedMapping)
    }

    const removeCarrier = (carrierId) => {
        const updatedMapping = ([...carrierMappings]).filter(carrierMapping => carrierMapping.carrier !== carrierId)

        setCarrierMappings(updatedMapping)
    }

    const addCarrier = (carrier) => {
        setCarrierMappings([...carrierMappings].concat({ carrier: carrier._id, zips: "" }))
    }

    const addableCarrier = (carrier, i) => {
        const isInList = carrierMappings.find(c => c.carrier === carrier._id)

        return (
            <div key={i} className={isInList ? "inlistCarrier" : "addableCarrier"} onClick={() => isInList ? removeCarrier(carrier._id) : addCarrier(carrier)}>
                {carrier.organization}
            </div>
        )
    }

    const save = () => {
        dispatch(saveCarrierMappings(vendor._id, carrierMappings)).then(t => {
            swalNotify("Sparat!")
        })
    }

    const carrierMappning = (mapping, i) => {
        const carrier = carriers.find(c => c._id === mapping.carrier)
        if (!carrier) return null

        return (
            <div key={i} className="carrierMapping">
                <div><b>{carrier.organization}</b><div className="qCloseButton" onClick={() => removeCarrier(mapping.carrier)}>Ta bort</div></div>
                <br />
                <div className="addZipCodeBtn" onClick={() => addNewZip(mapping)}>Lägg till postnummer <Glyphicon glyph="glyphicon glyphicon-plus"></Glyphicon></div>
                <br />
                {mapping.zips.split(';').map((zip, i) => {
                    return (
                        <div style={{ width: "100%", display: 'flex', marginTop: 3 }} key={i}>
                            <div style={{ width: "20%" }}>
                                <input type="text" value={zip} size="6" onChange={e => modifyZip(mapping, i, e.target.value)} />
                            </div>

                            <div style={{ width: "50%" }}>
                                <div className="addZipCodeBtn" onClick={() => removeZip(mapping, i)}>Ta bort <Glyphicon glyph="glyphicon glyphicon-minus"></Glyphicon></div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }


    return (
        <Modal
            ariaHideApp={false}
            isOpen={true}
            onRequestClose={closeModal}
            style={getModalStyles(.5)}
            contentLabel="E">

            <div className="qCloseButton" onClick={closeModal}>Stäng</div>

            <h3>{vendor.name}</h3>

            <div>
                <p>
                    Denna funktion är så fiffig att om man t.ex vill att en transportör ska täcka hela Stockholm för denna leverantören så
                    räcker det med att skriva siffran 1 som postnummer.
                    Då mappas 1xxxx dit!
                </p>
                <p>
                    Om man vill att leverantören ska ha två transportörer (som Ahlsell), så kan man lägga till dem två och skapa deras avgränsade postnummer!
                    Detta speglas sedan i Onboarding-systemet under Enhetskommunikation -> Transportörer.
                </p>
            </div>

            <div style={{ width: "100%", display: 'flex', height: "70%" }}>
                <div className="leftPane">
                    {carriers.map(addableCarrier)}
                </div>
                <div className="rightPane">
                    {(carrierMappings || []).map(carrierMappning)}
                </div>
            </div>
            <br />
            <div className="qSaveButton" onClick={save}>
                Spara
            </div>
        </Modal>
    )
}